import React from 'react';
import {NavLink} from 'react-router-dom';
import user_icon_01 from '../../assets/img/icons/actions-user_icon_01.svg';
import user_icon_02 from '../../assets/img/icons/actions-user_icon_02.svg';
import user_icon_03 from '../../assets/img/icons/actions-user_icon_03.svg';
import {useTranslation} from 'react-i18next';
import s from './UserActions.module.css';
import {useStatusRestriction} from '../../hooks/useStatusRestriction';

type Props = {};

const UserActions: React.FC<Props> = () => {
	const {t} = useTranslation();
	const restrictions = useStatusRestriction();
	const canShowNetworkIncome =
		restrictions.canShowMainNetworkIncomeAction &&
		restrictions.canAccessNetworkIncomePage;
	const canShowMyTeam = restrictions.canAccessMyTeamPage;
	const canShowPartnerIncome = restrictions.canAccessPartnerIncomePage;

	if (!canShowNetworkIncome && !canShowMyTeam && !canShowPartnerIncome) {
		return null;
	}

	return (
		<div className="user__column">
			<div className={s.userActions}>
				{canShowNetworkIncome && (
					<div className={s.actionColumn}>
						<NavLink to={'/my_bonus'} className={s.actionItem}>
							<div className={`${s.actionIcon} ${s.actionIconBrown}`}>
								<img src={user_icon_01} alt="actions-user_icon" />
							</div>
							<div className={s.actionTitle}>{t('Мій дохід з мережі')}</div>
						</NavLink>
					</div>
				)}
				{canShowMyTeam && (
					<div className={s.actionColumn}>
						<NavLink to={'/my_team'} className={s.actionItem}>
							<div className={`${s.actionIcon} ${s.actionIconGreen}`}>
								<img src={user_icon_02} alt="actions-user_icon" />
							</div>
							<div className={s.actionTitle}>{t('Моя команда')}</div>
						</NavLink>
					</div>
				)}
				{canShowPartnerIncome && (
					<div className={s.actionColumn}>
						<NavLink to={'/my_accounts'} className={s.actionItem}>
							<div className={`${s.actionIcon} ${s.actionIconBlue}`}>
								<img src={user_icon_03} alt="actions-user_icon" />
							</div>
							<div className={s.actionTitle}>{t('Мій дохід')}</div>
						</NavLink>
					</div>
				)}
			</div>
		</div>
	);
};

export default UserActions;
